import React from 'react';
import ConfirmDialog from '@shared/components/confirmDialog/ConfirmDialog';

/**
 * @typedef {object} AppraiserAppraisalsRemoveContainerProps
 * @property {Array<*>} [assignedAppraisals]
 * @property {boolean} [openConfirmDialog]
 * @property {(checked: boolean) => void} [setOpenConfirmDialog]
 * @property {number} [selectedAppraisalToUnassign]
 * @property {(selected: null) => void} [setSelectedAppraisalToUnassign]
 * @property {(appraiserFormData: Object | ((prev: Object) => Object)) => void} [setAppraiserFormData]
 */

/**
 * @param {AppraiserAppraisalsRemoveContainerProps} props
 */
const AppraiserAppraisalsRemoveContainer = props => {
  const {
    openConfirmDialog,
    setOpenConfirmDialog,
    selectedAppraisalToUnassign,
    setSelectedAppraisalToUnassign,
    setAppraiserFormData,
    assignedAppraisals
  } = props;

  const handleUnassignAppraisal = () => {
    handleCloseDialog();

    setAppraiserFormData(prev => ({
      ...prev,
      assignedAppraisals: assignedAppraisals.filter(x => x.id !== selectedAppraisalToUnassign)
    }));
  };

  const handleCloseDialog = () => {
    setSelectedAppraisalToUnassign(null);
    setOpenConfirmDialog(false);
  };

  return (
    <ConfirmDialog
      open={openConfirmDialog}
      handleClose={handleCloseDialog}
      handleOnConfirm={handleUnassignAppraisal}
      cancelBtnText='No'
      confirmBtnText='Yes'
      message='Are you sure you want to remove this Appraisal assignment?'
    />
  );
};

export default AppraiserAppraisalsRemoveContainer;
